import { gql } from '@apollo/client';
import { DEPARTMENT_FIELDS } from '../../fragments';
import { AddDepartmentProps, UpdateDepartmentProps } from './department.types';
import { DepartmentType } from '../../../types';
import { GET_DEPARTMENT_BY_ID } from '../../queries';

export const ADD_DEPARTMENT = gql`
  ${DEPARTMENT_FIELDS}
  mutation AddDepartment(
  $organizationId: ID!,
  $name: String!,
  $headOfDepartmentId: ID) {
    addDepartment(
    organizationId: $organizationId,
    name: $name,
    headOfDepartmentId: $headOfDepartmentId,
    ){
      ...DepartmentFields
    }
  }
`;

export function addDepartment({
  client,
  organizationId,
  name,
  headOfDepartmentId,
}: AddDepartmentProps) {
  return client?.mutate<{ addDepartment: DepartmentType }>({
    mutation: ADD_DEPARTMENT,
    variables: {
      organizationId,
      name,
      headOfDepartmentId,
    },
    refetchQueries: [
      GET_DEPARTMENT_BY_ID,
    ],
  });
}

export const UPDATE_DEPARTMENT = gql`
  ${DEPARTMENT_FIELDS}
  mutation UpdateDepartment(
  $departmentId: ID!
  $headOfDepartmentId: ID,
  $organizationId: ID,
  $name: String,
  ){
    updateDepartment(
    departmentId: $departmentId,
    organizationId: $organizationId,
    headOfDepartmentId:$headOfDepartmentId,
    name: $name
    ){
      ...DepartmentFields
    }
  }
`;

export function updateDepartment({
  client,
  departmentId,
  name,
  organizationId,
  headOfDepartmentId,
}: UpdateDepartmentProps) {
  return client?.mutate<{ updateDepartment: DepartmentType }>({
    mutation: UPDATE_DEPARTMENT,
    variables: {
      departmentId,
      name,
      organizationId,
      headOfDepartmentId,
    },
    refetchQueries: [
      GET_DEPARTMENT_BY_ID,
    ],
  });
}
